import TimeSeriesChart, { chartColor } from '../shared/TimeSeriesChart';

const DEFAULT_LINE_COLOR = chartColor('redesign.accent.assets');
const DEBT_LINE_COLOR = chartColor('redesign.accent.expense');

/**
 * Assets and debt over time, for the accounts overview.
 *
 * Thin adapter over the shared TimeSeriesChart — it only names the two series;
 * hover, gradients and dots are the shared component's job.
 */
export default function DualBalanceChart({
  assets = [],
  expenses = [],
  periods = [],
  granularity = 'month',
  singleLine = false,
  lineColor = DEFAULT_LINE_COLOR,
  height = 92,
  onHover,
}) {
  const series = [{ key: 'assets', values: assets, color: lineColor, strokeWidth: 3, fill: true }];
  if (!singleLine) {
    // solid, like the assets line: this is measured debt, not a projection
    series.push({ key: 'debt', values: expenses, color: DEBT_LINE_COLOR, strokeWidth: 3 });
  }

  return (
    <TimeSeriesChart
      series={series}
      periods={periods}
      granularity={granularity}
      height={height}
      onHover={onHover}
    />
  );
}
